<template>
    <div id="tarContainer">
        <div class="row">
            <div class="col-12">
                <MdTitle v-bind:Text="$t('Nurses.tarsList')" />  
                <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                    <div class="input-group" dir="ltr">
                        <input type="text" class="form-control" :dir="dirInput" v-model="parameter.SearchCriteria"
                            @keyup.enter="SearchPatients" />

                        <div class="input-group-append">
                            <MdButton v-bind:Name="'btnsearchinput'" v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'" v-on:click="SearchPatients">
                            </MdButton>
                        </div>
                    </div>
                </div>


            
                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <!--<MdEdit 
                            v-bind:Label="$t('Nurses.DateTimeFrom')"                      
                            v-bind:TypeProp="'datetime-local'" 
                            v-bind:Name="'DateFrom'"										
                            v-bind:Id="'input_date_from'"
                            v-bind:Min="'1900-01-01T00:00'"
                            v-bind:isRequired="true"
                            v-bind:isValid="IsValidDateandTimeFrom"                       
                            v-bind:Max="'2200-12-31T23:59'" 
                            :OnPressEnter="getListing" 
                            v-on:blur="getListing"                 
                            v-model="DateFrom"/>  -->
                        <MdDateTime 
                            :Label="$t('Nurses.DateTimeFrom')" 
                            :Model="DateFrom"                           
                            @input="DateFrom = $event"                            
                            :Id="'TarsDateTimeFrom'"
                            :Type="'datetime'"
                            :OnPressEnter="getListing"
                            :isRequired="true"                           
                            :isConfirm="false"
                            :ReadOnly="false">
                        </MdDateTime>        
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <!--<MdEdit 
                            v-bind:Label="$t('Nurses.DateTimeTo')"                      
                            v-bind:TypeProp="'datetime-local'"  
                            v-bind:isRequired="true"
                            :OnPressEnter="getListing"
                            v-bind:isValid="IsValidDateandTimeTo" 
                            v-bind:Min="'1900-01-01T00:00'"
                            v-bind:Max="'2200-12-31T23:59'" 
                            v-on:blur="getListing"                      
                            v-model="DateTo"/>-->
                        <MdDateTime 
                            :Label="$t('Nurses.DateTimeTo')" 
                            :Model="DateTo"                           
                            @input="DateTo = $event"                            
                            :Id="'TarsDateTimeTo'"
                            :Type="'datetime'"
                            :OnPressEnter="getListing"
                            :isRequired="true"                           
                            :isConfirm="false"
                            :ReadOnly="false">
                        </MdDateTime>  
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.Program')"
                            v-bind:Options="ProgramList"
                            v-bind:Model="ProgramVmodel"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'"
                            v-bind:Placeholder="selectPlaceholder"
                            v-bind:Multiple="false"
                            v-bind:RequireEvent="true"
                            v-bind:IfUsevalidation="false"
                            :Input="ChangeDropDownPrograms"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$tc('Shared.Patient')"
                            v-bind:Options="PatientList"
                            v-bind:Model="Patients"
                            v-bind:FieldDescription="'patientname'"
                            v-bind:FieldCode="'patientcode'"
                            v-bind:Multiple="false"                       
                            :Input="ChangeDropDownPatients"/>                  
                    </b-col>
                </b-row>

                <b-row>
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Building')"
                            v-bind:Options="BuildinsList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="buildings"   
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownBuilding"
                            v-bind:IsDisabled="!buildingsEnabled"/>
                    </b-col>  
                    <b-col lg="3" md="3" sm="12">
                        <MdSelect
                            v-bind:Label="$t('Shared.Level')"
                            v-bind:Options="LevelList"
                            v-bind:FieldDescription="'description'"
                            v-bind:FieldCode="'code'"
                            v-bind:Model="level"                       
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownLevel"/>
                    </b-col>
                    <b-col lg="3" md="3" sm="12">                  
                        <MdSelect
                            v-bind:Label="$tc('Shared.Room')"
                            v-bind:Options="RoomList"
                            v-bind:FieldDescription="'name'"
                            v-bind:FieldCode="'code'" 
                            v-bind:UseResetModel="true"                 
                            v-bind:Model="room"                       
                            v-bind:Multiple="false"
                            :Input="ChangeDropDownRoom"/>
                    </b-col>                            
                </b-row>

                <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <div class="mt-3 text-right">
                            <button 
                                v-on:click="SearchPatients"
                                type="button"
                                class="btn btn-primary btn-login mx-2"												
                                id="btnsearchinput">
                                {{ $t('Shared.Search') }}
                            </button>
                        </div>
                    </b-col>
                </b-row>
            
                <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

                <div v-if="showEmptyRecords" v-bind:style="emptyRecordsStyle" role="alert" aria-live="polite"><div class="text-center my-2">{{$t('MdTable.nRecShow')}}</div></div>
            
                <div class="container-mars">
                    <div class="card-container">
                        <div class="card" v-for="item in items" :key="item.admissionRecordId">
                            <div class="card-body overdue-card">
                                <div class="row">
                                    <div class="col-md-4">
                                        <img v-on:click="ViewPatientOrder(item)" v-if="item.patientPhoto !== null && item.patientPhoto !== ''" v-bind:src="'data:image/'+'.'+item.patientPhotoExtension+';base64,'+item.patientPhoto" alt="Foto" class="photo img-fluid">                                    
                                        <img v-on:click="ViewPatientOrder(item)" v-if="(item.patientPhoto === null || item.patientPhoto === '') && item.sex === 'Male'" src="@/assets/images/faces/nopic-male.jpg" alt="Foto" class="photo img-fluid">
                                        <img v-on:click="ViewPatientOrder(item)" v-if="(item.patientPhoto === null || item.patientPhoto === '') && item.sex === 'Female'" src="@/assets/images/faces/nopic-female.jpg" alt="Foto" class="photo img-fluid">
                                        <span class="d-flex justify-content-center uId" v-b-tooltip.hover :title="$t('Shared.PatientId')">{{item.patientCode}}</span>
                                    </div>

                                    <div class="col-md-8 cContent">
                                        <h5 v-on:click="ViewPatientOrder(item)"
                                            class="card-title"
                                            :class="{
                                                'overdue': item.administrationStatus === '1_OVER_DUE',
                                                'close-to-admin': item.administrationStatus === '2_CLOSE_TO_ADM',
                                                'prior-to-admin': item.administrationStatus === '3_PRIOR_TO_ADM',
                                                'no-pending': item.administrationStatus === '4_NO_PEND_ADM'
                                        }">
                                            <i 
                                                id="rm-allergic"
                                                v-if="item.allergies && !item.specialPrecautions" 
                                                class="mdi mdi-alert allergies helpCursor castIconShadow" 
                                                v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}:`+item.allergies" 
                                                variant="primary">
                                            </i>

                                            <i 
                                                id="rm-allergic" 
                                                v-if="!item.allergies && item.specialPrecautions" 
                                                class="mdi mdi-alert allergies helpCursor castIconShadow"
                                                v-b-tooltip.hover="`${$t('Shared.PatientSpecialPrecautions')}: `+item.specialPrecautions" 
                                                variant="primary">
                                            </i>

                                            <i 
                                                id="rm-allergic" 
                                                v-if="item.allergies && item.specialPrecautions" 
                                                class="mdi mdi-alert allergies helpCursor castIconShadow"
                                                v-b-tooltip.hover="`${$t('RigthBar.ALLERGIC')}: `+item.allergies + ` / ` + $t('Shared.PatientSpecialPrecautions') +': '+ item.specialPrecautions" 
                                                variant="primary">
                                            </i>

                                            {{item.patientName}}
                                            
                                            <i
                                                class="ikon float-right mr-1 text-white "
                                                :class="{
                                                    'med-adm-overdue': item.administrationStatus === '1_OVER_DUE',
                                                    'med-adm-close': item.administrationStatus === '2_CLOSE_TO_ADM',
                                                    'med-adm-prior': item.administrationStatus === '3_PRIOR_TO_ADM',
                                                    'med-adm-not-pending': item.administrationStatus === '4_NO_PEND_ADM'
                                                    }"
                                                
                                                v-b-tooltip.hover :title="$t('Shared.Status')+': ' + item.administrationStatusTranslated">
                                            </i>
                                        </h5>

                                        <p class="card-text"><i class="fa fa-birthday-cake icon" v-b-tooltip.hover :title="$t('Shared.Dob')"></i><span v-if="item.dob">{{ item.dob }}</span><span v-else>- - / - - / - - - -</span></p>
                                        <p class="card-text text-truncate"><i class="fa fa-users icon" v-b-tooltip.hover :title="$tc('Shared.Program')+': ' + item.programName"></i>{{item.programName}}</p>
                                        <p class="card-text text-truncate">
                                            <i class="fa fa-building icon" v-b-tooltip.hover :title="$t('Shared.Building')+': ' + item.buildingName"></i><span v-if="item.buildingName">{{ item.buildingName }}</span><span v-else>Not defined</span>                                        
                                        </p>
                                        <p class="card-text text-truncate">
                                            <i class="fa fa-door-open icon" v-b-tooltip.hover :title="$tc('Shared.Room')+': ' + item.roomName"></i><span v-if="item.roomName">{{item.roomName}}</span><span v-else>Not defined</span>
                                        </p>
                                        <p class="card-text">
                                            <i class="fa fa-arrow-up icon" v-b-tooltip.hover :title="$t('Nurses.Floor')"></i><span v-if="item.roomLevel">{{item.roomLevel}}</span><span v-else>-</span>
                                            <i class="fa fa-bed icon" v-b-tooltip.hover :title="$tc('Shared.Bed')"></i><span v-if="item.bedName">{{item.bedName}}</span><span v-else>-</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <hr/>
                <TarsOrderModal  
                    v-if="VisibleOrder" 
                    @ModalTPTarsOrder="ModalTPTarsOrder"              
                    v-bind:PatientCode="PatientCodeSelected"
                    v-bind:DateFrom="DateFrom"
                    v-bind:DateTo="DateTo"
                    v-bind:PhotoObj="PhotoObj"
                    v-bind:ModalId="'modalTarsOrder'"
                    v-bind:TitleWindow="$t('Nurses.TarsMedication')">
                </TarsOrderModal>

                <div class="row mt-4" dir="ltr">
                    <div class="my-1 col-sm-7 col-md-6">
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalRows"
                            :per-page="perPage"
                            @change="onChange"
                            pills
                            size="lg"
                        ></b-pagination>
                    </div>
                    <div align="right" class="mr-2 col">
                        {{ $t('Shared.Show') }}
                        <b-form-select 
                            v-model="perPage" 
                            :options="options" 
                            size="sm" 
                            id="perPageSelect"
                            v-bind:style="perPageStyle"
                            @change="perPageChange">
                        </b-form-select>
                        {{ $t('Shared.Of') }} {{totalRows}}
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Permission from '@/common/Permission'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from "@/common/utils";
import EnumService from '@/services/enum.service'
import GlobalService from '@/services/global.service'
import PatientService from '@/services/patient.service'
import TarsService from '@/services/tars.service'
import UserPreference from "@/services/quickhelp.service"
import ClinicalService from '@/services/clinical.service'
import AdmissionService from '@/services/admission.service'
import MarsService from '@/services/mars.service'
import LocalStorage from '@/services/storage.service'
import TarsOrderModal from '@/components/pages/nurses/tars/tarsOrderModal'
import { EventBus } from '@/event-bus.js';
import moment from 'moment'

export default {
    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'TarsList',
    components: {
        TarsOrderModal
    },

    data() {
        return {
            OptionsRightMenu: {
                visible:false,
                btnvisible:false,
                ItemsList:[],
                favButtonAtion: false
            },
            IsValidDateandTimeFrom:true,
            IsValidDateandTimeTo:true,
            Patients:"",
            PatientList:[],
            PatientCode:"",
            DateFrom:null,
            DateTo:null,
            parameter:{  
                DateTimeFrom:null,
                DateTimeTo:null,       
                PatientList:[],
                LevelList:[],
                BuildingList:[],
                RoomList:[],
                ProgramList:[],
                SearchCriteria:null,
                PageSize:10,
                PageNumber:1
            },
            fullParam: {
                PageSize:0,
                PageNumber:0
            },
            showEmptyRecords: false,    
            perPage: 12,
            totalRows: 0, 
            currentPage: 1,   
            Header:{},
            items:[],
            emptyRecordsStyle: {
                backgroundColor: '#CF0',
                fontWeight: 'bold !important',
                textTransform: 'uppercase',
                padding: '2px',
                borderRadius: '50px',
                animation: 'fadeOut 10s ease-in-out infinite'
            },
            ProgramVmodel:[],
            ProgramList:[],
            selectPlaceholder: this.$t('Clinical.SelectOptions'),
            ProgramCode:"",
            dProgram:"",
            buildings:"",
            room:"",
            droom:"",
            level:"",
            BuildinsList:[],
            BuildingSelected:[],
            LevelList:[],
            RoomList:[],
            UserId: LocalStorage.getUserId(),
            VisibleOrder:false,
            PatientCodeSelected:"",
            PhotoObj:{patientPhoto:"",patientPhotoExtension:"",dob:null,patientName:"",sex:"",marsAlerts:"",},
            perPageStyle: {
                width: 'auto'
            },
            options: [
                { value: 4, text: '4' },
                { value: 12, text: '12' },
                { value: 40, text: '40' },
            ],
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        }
    }, 

    computed: {
        buildingsEnabled() {
            return Utils.isNullOrEmptyString(this.$store.state.restrictions.buildingLocation);
        }
    },

    methods: {
        SearchPatients() {
            this.$emit('load', true);
            this.currentPage = 1;
            this.getListing();
        },

        perPageChange(value) {
            this.perPage = value;      
            this.getListing();
        },

        onChange(page) {      
            this.currentPage = page;   
            this.getListing();  
        },

        ModalTPTarsOrder(){
            this.VisibleOrder = false;
        },

        async getListing(){
            if(this.validate_required()) {
                if (Utils.ValidateDate(this.DateFrom, Utils.getDateTimeFormatToIso()) && Utils.ValidateDate(this.DateTo, Utils.getDateTimeFormatToIso())) {
                    let parameters = {
                        ...this.parameter
                    }
                    parameters.PageNumber = this.currentPage;
                    parameters.PageSize = this.perPage;
                    parameters.DateTimeFrom = this.DateFrom;
                    parameters.DateTimeTo = this.DateTo;
                    if (!Utils.isNullOrEmptyString(this.$store.state.restrictions.buildingLocation)) {
                        parameters.BuildingList = [this.$store.state.restrictions.buildingLocation];
                    }
                    if (this.parameter.ProgramList.length === 0) {
                        parameters.ProgramList = [...this.$store.state.restrictions.programs];
                    }
                    this.$emit('load', true);

                    await TarsService.getAllListing(parameters)
                            .then((response) => {
                                if(response.status == '200' && response.data){
                                    this.items = response.data; 
                                    this.showEmptyRecords = response.data && response.data.length === 0 ? true : false;  
                                    let headerString = response.headers["x-pagination"];
                                    this.Header = JSON.parse(headerString);
                                    this.totalRows = this.Header.TotalCount;

                                    if(response.data.length > 0){                                            
                                        this.items.forEach(function(element) {
                                            if (element.dob)	
                                                element.dob = Utils.formatterDateToString(element.dob);                          
                                        });                                                
                                    }
                                }
                                this.$emit('load', false);  
                            })
                            .catch((error) => {                   
                                this.$emit('load', false);               
                                this.showResponseErrorMessage(error);
                            }); 
                } else{
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.ITime'),"error");
                }
            } else {
                this.$emit('load', false),     
                this.showMessage(this.$tc('Msg.Error'), this.$t('modalMarsMed.DateFromToRequired'), "errorAutoHide");  
            }
        },

        validate_required(){
            this.IsValidDateandTimeFrom = this.DateFrom ? true : false;
            this.IsValidDateandTimeTo = this.DateTo ? true : false;        
            return this.IsValidDateandTimeFrom  && this.IsValidDateandTimeTo; 
        },

        ChangeDropDownPatients(item){
            this.parameter.PatientList = [];
            item ? this.parameter.PatientList.push(item.patientcode) : this.parameter.PatientList = [];
            this.totalRows = 0;  
            this.getListing();
        },

        async ChangeDropDownPrograms(item){ 
            this.parameter.ProgramList = [];      
            item ? this.parameter.ProgramList.push(item.code) : this.parameter.ProgramList = [];
    
            await this.UpdateProgramPreference(item ? item.code : null)
            this.totalRows = 0;
            this.getListing();
        },

        async ChangeDropDownBuilding(item){
            this.parameter.BuildingList = [];
            item ? this.parameter.BuildingList.push(item.code) : this.parameter.BuildingList = [];  
            await this.getRomms({BuildingCodeList:this.parameter.BuildingList});
            await this.UpdateBuildingPreference(item ? item.code : null);
            this.parameter.RoomList = [];
            this.room ? this.parameter.RoomList.push(this.room) : this.parameter.RoomList;

            this.totalRows = 0;
            this.getListing();    
        }, 

        async ChangeDropDownLevel(item){
            this.parameter.LevelList = [];
            item ? this.parameter.LevelList.push(item.code) : this.parameter.LevelList = [];   
            await this.UpdateLevelPreference(item ? item.code : null);
            this.totalRows = 0;
            this.getListing();
        },

        ChangeDropDownRoom(item){
            this.parameter.RoomList = [];
            item ? this.parameter.RoomList.push(item.code) : this.parameter.RoomList = [];    
            this.totalRows = 0; 
            this.getListing();
        },

        ViewPatientOrder(item){ 
            this.PhotoObj.patientPhoto = item.patientPhoto;
            this.PhotoObj.patientPhotoExtension = item.patientPhotoExtension;
            this.PhotoObj.dob = item.dob;
            this.PhotoObj.weight = item.weight;
            this.PhotoObj.patientName = item.patientName;
            this.PhotoObj.programName = item.programName;
            this.PhotoObj.sex = item.sex;
            this.PhotoObj.ageFormatted = item.ageFormatted;
            this.PhotoObj.marsAlerts = item.marsAlerts;
            this.PhotoObj.allergies = item.allergies;
            this.PhotoObj.heights = item.heights;
            this.PhotoObj.specialPrecautions = item.specialPrecautions;       
            this.PatientCodeSelected = item.patientCode;
            this.VisibleOrder = true;
        },

        async getPatients(){   
            await PatientService.getAll(this.fullParam)
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0) {
                        this.PatientList = response.data;                          
                        this.PatientList.forEach(function(element) {	
                            element.patientname = element.firstname + " " + element.lastname + " - "+element.patientcode;   
                        });       
                    }       
                })
                .catch(error => {      
                    this.showResponseErrorMessage(error);
                });
        },

        async getDateTime() { 
            await GlobalService.getDateTime()
                .then((response) => {      
                    if (response.data) {                             
                        this.DateFrom = Utils.formatterToISO2(moment(response.data).subtract(1, 'hours').subtract(moment(response.data).minute(), 'minutes')); 
                        this.DateTo = Utils.formatterToISO2(moment(response.data).add(1, 'hours').subtract(moment(response.data).minute(), 'minutes')); 
                    }  
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                }); 
        },

        async UpdateProgramPreference(value){
            let program = {
                LastTarsProgram:value
            };
            await UserPreference.UpdateLastTarsProgram(this.UserId, program)
                        .catch((error) => {
                            this.showResponseErrorMessage(error);
                        });
        },

        async UpdateBuildingPreference(value){
            let building = {
                LastTarsBuilding:value
            };
            await UserPreference.UpdateLastTarsBuilding(this.UserId, building)
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },

        async UpdateLevelPreference(value){
            let level = {
                LastTarsLevel:value
            };
            await UserPreference.UpdateLastTarsLevel(this.UserId, level)
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },

        async getUserPreference() {
            await UserPreference.getQhUserPreference(this.UserId)
                    .then((response) => {
                        if (response.data && response.data.length > 0) {          
                            let lastTarsProgram = response.data[0].lastTarsProgram;
                            let lastTarsbuilding = response.data[0].lastTarsBuilding;
                            let lastTarsLevel = response.data[0].lastTarsLevel;
                            if(lastTarsProgram){           
                                this.ProgramVmodel = lastTarsProgram;
                                this.parameter.ProgramList = [];
                                this.parameter.ProgramList.push(lastTarsProgram);
                            }else{
                                this.ProgramVmodel = null;
                                this.parameter.ProgramList = [];
                            }

                            if (this.buildingsEnabled) {
                                if(lastTarsbuilding){           
                                    this.parameter.BuildingList = [];
                                    this.parameter.BuildingList.push(lastTarsbuilding);
                                }else{
                                    this.buildings = null;
                                    this.parameter.BuildingList = [];
                                }
                            }

                            if(lastTarsLevel){           
                                this.level = lastTarsLevel;
                                this.parameter.LevelList = [];
                                this.parameter.LevelList.push(lastTarsLevel);
                            }else{
                                this.level = null;
                                this.parameter.LevelList = [];
                            }
                        } 
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },

        async loadListing(){
            await this.getUserPreference();
            this.getListing();
        },

        async getPrograms(){
            const parameter = {
                programsRestriction:  this.$store.state.restrictions.programs
            }
            await ClinicalService.getPrograms(parameter)
                    .then((response) => {
                        if(response.status == '200' && response.data && response.data.length > 0){                        
                            this.ProgramList = response.data;                                          
                        }               
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });  
        },

        async getLevel(){
            let param = {
                CodeType:"RoomLevel",
                OrderBy:"SeqNo"
            };
            await GlobalService.getGlobalCustom(param)
                    .then((response) => {
                        if(response.status == '200' && response.data.length > 0){                          
                            this.LevelList = response.data;
                        }                             
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    }); 
        },

        async getRomms(build){       
            await MarsService.getMarsRooms(build)
                    .then((response) => {
                        if(response.status == '200' && response.data.length > 0){                         
                            this.RoomList = response.data;
                            if(this.RoomList.length === 1){
                                this.room = this.RoomList[0].code;
                            }else{
                                EventBus.$emit('OnResetModelSelect'); 
                                this.room = "";   
                            }

                        }                             
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });

        },

        async getBuildings(){
            await AdmissionService.getBuildings({Code: this.$store.state.restrictions.buildingLocation})
                    .then((response) => {
                        if(response.status == '200'){     
                            this.BuildinsList = response.data;     
                        
                            if (!this.buildingsEnabled) {
                                this.buildings = this.$store.state.restrictions.buildingLocation;
                            }                                        
                        }                             
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
        },
    },

    async mounted() {
        this.OptionsRightMenu.ItemsList = EnumService.ClinicalItems
        let layoutStatus = this.$store.state.layoutStatus;
        switch(layoutStatus) {
            case 'L0R1':
            this.OptionsRightMenu.favButtonAtion = true;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            case 'L1R0':
            case 'L1R1':
                this.OptionsRightMenu.btnvisible = false;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
            break;
            default:
                this.OptionsRightMenu.favButtonAtion = true;
                this.$emit('getVisibleMenu', this.OptionsRightMenu);
        }

        this.$emit('load', true),
        Promise.allSettled([this.getDateTime(), this.getPatients(), 
                this.getPrograms(), this.getLevel(), this.getBuildings(),
                this.getRomms({BuildingCodeList:[]}),])
            .then((result) => result.length === 6 ? this.loadListing() : null);
    },

    destroyed(){
        this.$store.commit('setWrotePasswordTars',false);
    }
}
</script>

<style scoped>

.patPhoto {
    position: relative;
    display: inline-block;
    overflow: hidden;
    padding-bottom: 10px;
    transition: transform 0.3s ease-in-out;
}

.patPhoto img {
    display: block;
    width: 100%;
    height: auto;
    border: 3px solid white;
    border-radius: 10px;
    object-fit: cover;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
}

.patPhoto:hover {
    transform: scale(1.2);
}
.patPhoto:hover img{
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.05);
}

.patPhoto::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0));
    transform: translateY(100%);
    transition: transform 0.5s ease-in-out;
}

.patPhoto:hover::after {
    transform: translateY(-100%);
}

.relocateIcon{
    position: absolute;
    top: 5px;
    right: 20px;
}
.relocateIconMed{
    position: absolute;
    top: 5px;
    right: 25px;
}

.cContent{
    padding-left: 0;
}
.card-container {
    display: flex;
    flex-wrap: wrap;
}
.card {
    flex: 0 1 calc(25% - 20px);
    margin-bottom: 20px;
    border-radius: 10px;
    margin-right: 10px;
    margin-left: 10px;
}
.card-body{
    border-radius: 10px;
    background: linear-gradient(300deg, #F9F9F9, #FFF);
    padding: 0.8rem 0.4rem 0.6rem 0.4rem;
    transition: all 1s ease;
}
.card-title{
    padding: 5px 0 5px 5px;
    margin-bottom: 5px;
    border-radius: 0 5px 0 0;
    transition: all 1s ease;
    cursor: pointer;
}
.card .card-title i::before, .card .icon {
    cursor: help;
}
.card:hover .card-title.overdue i::before{
        color: #ffd6d6 !important;
}
.card:hover .card-title.close-to-admin i::before{
        color: #fcfcb2 !important;
}
.card:hover .card-title.prior-to-admin i::before{
        color: #afffaf !important;
}
.card:hover .card-title.no-pending i::before{
        color: #00f2ff !important;
}
.card:hover .card-title i::before{
        text-shadow: none !important;
}

.card-title::before{
    content: '►';
    position: absolute;
    left: -5px;
    top: 2px;
    opacity: 0;
    transition: all .5s ease-in-out;
    font-size: 20px;
    transform: scale(.4);
}
.card-text{
    color: #666;
    padding-left: 5px;
    margin-top: .7em;
    text-transform: lowercase capitalize;
}

@media (max-width: 1200px) {
    .card {
        flex: 0 1 calc(33.333% - 20px);
    }
}
@media (max-width: 992px) {
    .card {
        flex: 0 1 calc(50% - 20px);
    }
}
@media (max-width: 576px) {
    .card {
        flex: 0 1 100%;
    }
}
@media (min-width: 765px) {
    .card:hover .photo{
        transform: rotateY(10deg) rotateX(1deg) rotateZ(-5deg) scale(1.1);
        transform-style: preserve-3d;
    }
    .card:hover .card-title{
        text-shadow: 0 0 #FFF, -1px 0 6px #FFF, 1px 0 6px #FFF, 0 -1px 6px #FFF, 0 1px 6px #FFF ;
        color: #000;
    }
    .photo{
        height: 148px !important;
    }
}
@media (max-width: 765px) {
    .cContent{
        padding-left: 15px;
    }
}
.card-container::after {
    content: "";
    flex: auto;
}
.overdue {
    background: linear-gradient(90deg, #D6454500, var(--overdue));
}
.close-to-admin {
    background: linear-gradient(90deg, #D9A44100, var(--close-to-admin));
}
.prior-to-admin {
    background: linear-gradient(90deg, #4FA94F00, var(--prior-to-admin));
}
.no-pending {
    background: linear-gradient(90deg, #5E99D900, var(--no-pending));
}

.icon {
    z-index: 1;
    margin: 0 5px 0 5px;
    color: #CCC;
    transition: all 0.4s ease-in-out;
    width: 1.3em;
    text-align: center;
}
.icon:hover {
     color: #000;
     position: relative;
     text-shadow: 2px 2px 1px #CCC;
     top: -1px;
     left: -1px;
}
.photo-container {
    perspective: 300px;
    z-index: 2;
}
.photo {
    width: 100%;
    height: 100px;
    cursor: pointer;
    object-fit: cover;
    border-radius: 10px;
    border: 4px solid #F3F3F3;
    filter: grayscale(100%) brightness(1.2); 
    transition: all 0.4s;
    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
}
.card:hover .photo {
    border: 4px solid #EEEEEE;
    filter: grayscale(0%) brightness(0.99);
    box-shadow: 8px 8px 6px rgba(0, 0, 0, 0.05);
}
.card:hover .card-body{
    background: linear-gradient(120deg, #F1F1F1, #FFF);
}
.card:hover .card-title{
    margin-left: 20px;
}
.card:hover .card-title::before{
    opacity: 1;
    left: 3px;
    transform: scale(1);
}
.card:hover .uId{
    background: linear-gradient(90deg, #FFFFFF00, #FFFFFFFF, #FFFFFFFF, #FFFFFFFF, #FFFFFF00);
}
p i:not(:first-of-type) {
    margin-left: 1.1em;
}

.uId{
    font-size: .7em;
    color: #999;
    cursor: help;
    position: inherit;
    left: 0;
    z-index: 1;
    border-top: 1px solid;
    border-bottom: 1px solid;
    border-image: linear-gradient(to right, #CCCCCC00, #CCCCCCFF, #CCCCCC00) 1;
    margin-top: .5em;
    background: linear-gradient(90deg, #FFFFFF00, #FFFFFFFF, #FFFFFF00);
    transition: all 0.4s;
}
.uId:hover{
    color: #000;
    left: 2px;
}
.castIconShadow{
    color: yellow !important;
    filter: drop-shadow(0 0 1px #00000066);
    transition: filter 1s ease-in-out;
}
.castIconShadow:hover{
    color: yellow !important;
    filter: drop-shadow(1px 1px 1px #00000066);
    transition: filter .3s ease-in-out;
}
</style>